import React from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';

//HELPERS
import $ from 'jquery';
import * as c from '../helpers/constants'
import { callApi } from '../helpers/methods'

//REDUX
import { connect } from 'react-redux';
//import { bindActionCreators } from 'redux';
//import { authActionsPrivate } from '../store/auth';

//LAYOUT
import PrivateLayout from '../layouts/private'

//COMPONENTS
import Error404 from './error404';
import Configuracao from '../components/config/configuracao';
import Usuario from '../components/config/usuario';
import Empresas from '../components/config/empresas';
import CentroCusto from '../components/config/centroCusto';
import GerenciadorDominios from '../components/config/gerenciadorDominios';
import ParametroUsuario from '../components/config/parametroUsuario';
import alteraSenha from '../components/config/alteraSenha';
import cadastroCampos from '../components/config/cadastroCampos';
import produtos from '../components/config/produtos';
import remetenteValidator from '../components/config/remetenteValidator';


class ConfiguracaoUsuario extends React.PureComponent
{
    constructor(props)
    {
        super(props);
    }

    render()
    {
        return (            
            <PrivateLayout navActiveItem={c.NAV_REPORT}>

                <Switch history={this.props.history}>                           
                    <Redirect exact from={c.REPORT_ROUTE} to={c.REPORT_ROUTE+"/configuracao"} />
                    
                    <Route exact path={c.REPORT_USUARIO+"/configuracao"} component={Configuracao} />
                    <Route exact path={c.REPORT_USUARIO+"/usuarios"} component={Usuario} />   
                    <Route exact path={c.REPORT_USUARIO+"/empresas"} component={Empresas} />   
                    <Route exact path={c.REPORT_USUARIO+"/campos"} component={cadastroCampos} />
                    <Route exact path={c.REPORT_USUARIO+"/produtos"} component={produtos} />   
                    <Route exact path={c.REPORT_USUARIO+"/centrocusto"} component={CentroCusto} />   
                    <Route exact path={c.REPORT_USUARIO + "/gerenciadordominio"} component={GerenciadorDominios} />
                    <Route exact path={c.REPORT_USUARIO + "/remetentes-validos"} component={remetenteValidator} />
                    <Route exact path={c.REPORT_USUARIO + "/seguranca"} component={ParametroUsuario} />
                    <Route exact path={c.REPORT_USUARIO+"/alterar-senha"} component={alteraSenha} />
                    <Route component={Error404} />                   
                </Switch>

            </PrivateLayout>
        );
    }  
}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfiguracaoUsuario));
